/**
 * NotificationAdapter via the browser Notification API. Works in both real
 * browsers and Electron renderers, so both shells can use it as the base
 * NotificationAdapter.
 *
 * `notify` silently drops if permission is not "granted" (the caller should
 * have requested permission during a user gesture). Interactive notifications
 * with action buttons are Desktop-only (served by a separate adapter that
 * implements InteractiveNotificationAdapter); UI narrows via
 * `supportsInteractiveNotifications`.
 */
export const browserNotificationAdapter = {
    async notify(options) {
        if (typeof Notification === "undefined")
            return;
        if (Notification.permission !== "granted")
            return;
        const n = new Notification(options.title, {
            body: options.body,
            tag: options.tag,
            silent: options.silent,
        });
        if (options.onClick) {
            n.onclick = () => {
                window.focus();
                options.onClick();
                n.close();
            };
        }
    },
    async requestPermission() {
        if (typeof Notification === "undefined")
            return "denied";
        if (Notification.permission === "granted")
            return "granted";
        if (Notification.permission === "denied")
            return "denied";
        return Notification.requestPermission();
    },
};
//# sourceMappingURL=notifications.js.map